import request from '@/utils/request'

let Ma_companyApi = {

  /*企业列表*/
  list(data) {
    return request._post('/shop/plus.ma_company.Index/index', data);
},
/*添加企业*/
add(data) {
    return request._post('/shop/plus.ma_company.Index/add', data);
},
/*修改企业*/
edit(data) {
    return request._post('/shop/plus.ma_company.Index/edit', data);
},
editadministrator(data) {
    return request._post('/shop/plus.ma_company.Index/administrator', data);
},
/*删除企业*/
del(data) {
    return request._post('/shop/plus.ma_company.Index/del', data);
},
/*企业详情*/
detail(data) {
  return request._post('/shop/plus.ma_company.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_company.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_company.Setting/getSetting', data, errorback);
    },
}
export default Ma_companyApi;



// WEBPACK FOOTER //
// ./src/api/ma_company.js